export default class InactiveFilter extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSearch();
    }

    initSearch(){
        $('#searchZone').on('input', function (code) {
            var search = $(this).val();
            var countDisplay = 0;
            $('.product-item').each(function(i, obj){
                if(search == ""){
                    $(obj).css('display','block');
                    countDisplay++;
                }
                else{
                    var check = 'none';
                    var reference = $(obj).find('.card-ref').html().toUpperCase();
                    var name = $(obj).find('.card-title-2').html().toUpperCase();

                    if(reference.includes(search.toUpperCase())){
                        check = 'block';
                        countDisplay++;
                    }

                    if(name.includes(search.toUpperCase())){
                        check = 'block';
                        countDisplay++;
                    }
                    $(obj).css('display',check);
                }
            });
            if(countDisplay == 0){
                $('.no-result-zone').removeClass('d-none');
                $('.no-result-zone').addClass('d-block');
            }
            else{
                $('.no-result-zone').removeClass('d-block');
                $('.no-result-zone').addClass('d-none');
            }
        });
    }

}